module.exports = __webpack_public_path__ + "img/csr_logo_04.43cc95a6.png";